import Zergling from '../helpers/zergling';
import cookie from 'react-cookie';
import Config from "../config/main";
import {UILoading, UILoadingDone, UILoadingFailed, OpenPopup} from "./ui";
import {t} from '../helpers/translator';
import { UserDidLogin } from "../actions/terminal";
import {REALLY_LOGGED_IN, LOGGED_IN, LOGGED_OUT, LOGIN_START, LOGIN_FAILED, CAPTCH_LOAD_SUCCESS, CAPTCH_LOAD_FAILURE} from './actionTypes/';
import { toast } from 'react-toastify'

/**
 * @description User Logged in state
 * @param {Object} message
 * @returns {Object} new State
 */
export const LoggedIn = (message) => {
    return {
        type: LOGGED_IN,
        payload: message
    };
};

/**
 * @description Login status check result
 * @param {Boolean} message
 * @returns {Object} new State
 */
export const ReallyLoggedIn = (message) => {
    return {
        type: REALLY_LOGGED_IN,
        payload: message
    };
};

/**
 * @description Logout confirmation
 * @param {Object} message
 * @returns {Object} new State
 */
export const LoggedOut = (message) => {
    return {
        type: LOGGED_OUT,
        payload: message
    };
};

/**
 * @description Start login process
 * @param {Object} message
 * @returns {Object} new State
 */
export const LoginStart = (message) => {
    return {
        type: LOGIN_START,
        payload: message
    };
};

/**
 * @description User Logged Failed
 * @param {Object} message
 * @returns {Object} new State
 */
export const LoginFailed = (message) => {
    return {
        type: LOGIN_FAILED,
        payload: message
    };
};

/**
 * @description User login
 * @param {String} username
 * @param {String} password
 * @param {Boolean} remember
 * @returns {Function} async action dispatcher
 */
export function Login (username, password, remember, additionalParams) {
    return function (dispatch) {
        return Zergling
            .login({username, password}, null, additionalParams)
            .then((response) => {
                if (remember) {
                    cookie.save('authData', response.data, {path: '/', expires: new Date(Date.now() + Config.main.authSessionLifeTime * 1000)});
                } else {
                    response.data.prolongLessTime = true;
                    cookie.save('authData', response.data, {path: '/', expires: new Date(Date.now() + Config.main.authSessionLessLifeTime * 1000)});
                }
                dispatch(UserDidLogin({userId: response.data.user_id, currency: JSON.parse(sessionStorage.getItem("authData")).currency}));
            })
            .catch((data) => {
                dispatch(LoginFailed(data));
            });
    };
}

/**
 * @description Logout user
 * @returns {Function} async action dispatcher
 */
export function Logout (isIdle) {
    return function (dispatch) {
        cookie.remove('authData', { path: '/' });

        isIdle && toast.error(t('You have been logged out due to inactivity'));

        return Zergling.logout(dispatch);
    };
}

/**
 * @description Restore login
 * @param {Object} authData
 * @returns {Function} async action dispatcher
 */
export function RestoreLogin (authData) {
    return function (dispatch) {
        dispatch(UILoading("restoreLogin"));
        Zergling.setAuthData(authData);
        return Zergling
            .login(null)
            .then(() => { dispatch(UILoadingDone("restoreLogin")); })
            .catch((data) => {
                dispatch(UILoadingFailed("restoreLogin"));
                dispatch(LoginFailed(data));
                console.error(data);
            });
    };
}